
import request from '@/utils/http';

// 分页查询防串货在途预警列表
export const queryByPage = data => {
    return request({
        url: `/api-antms/query/dispatch/changeMonitor/queryByPage`,
        method: 'post',
        data
    });
};

// 防串货在途预警-处理预警数据
export const handleWarningData = data => {
    return request({
        url: `/api-antms/transport/dispatchChangeMonitor/handleWarningData`,
        method: 'post',
        data
    });
};

// 防串货在途预警明细-发车单高德规划轨迹
export const getGoldePoint = data => {
    return request({
        url: `/api-antms/query/dispatch/amap/location/point`,
        method: 'get',
        params: data
    });
};

// 防串货在途预警明细-发车单真实轨迹
export const getDriverTrack = data => {
    return request({
        url: `/api-antms/query/dispatch/monitor/location/point`,
        method: 'get',
        params: data
    });
};

// 防串货在途预警-发车单预警数据处理列表
export const getWarning = data => {
    return request({
        url: `/api-antms/query/dispatchChangeMonitor/warningData`,
        method: 'get',
        params: data
    });
};

// 防串货在途预警-获取高德首次规划线路数据
export const getPlanLine = data => {
    return request({
        url: `/api-antms/query/dispatchChangeMonitor/planLine`,
        method: 'get',
        params: data
    });
};
